import { ICategoryWithChildren } from 'src/components/MenuSectionItems/utilities';
import { IMenuItem } from 'src/types/menu.types';

export const getPromptText = (name: string, items: IMenuItem[], subcategories: ICategoryWithChildren[]) => {
  if (subcategories.length)
    return 'All items within this section and its subsections will be moved to the "Unassigned" menu section. All subsections will be deleted. This action cannot be undone.';
  if (items.length) return 'All products will be moved to the "Unassigned" menu section.';
  return `This will permanently delete ${name}.`;
};
